import React from 'react';

export default function Spinner() {
    return (
        <div className="px-10 py-4 flex flex-col items-center justify-center">
            <div className="animate-spin h-10 w-10 rounded-full border border-4 border-cs16 border-t-cs8"></div>
        </div>
    );
}
